<div class="gc-page">
  <ngx-loading [show]="isLoading"></ngx-loading>

  <!-- ══════════════════════════════════════════
       HERO HEADER
  ══════════════════════════════════════════ -->
  <div class="gc-hero">
    <div class="gc-hero__scanlines"></div>
    <div class="gc-hero__glow"></div>

    <div class="container-fluid px-3 px-md-4">
      <div class="row g-3 align-items-center">
        <!-- Avatar + Player -->
        <div class="col-12 col-sm-auto d-flex flex-column align-items-center align-items-sm-start">
          <div class="gc-section-label">
            <i class="fa fa-user-circle-o"></i> {{ 'PROFILE.AVATAR_BLOCK.TITLE' | translate }}
          </div>
          <br />
          <div class="gc-avatar mt-1">
            <div class="gc-avatar__ring"></div>
            <div class="gc-avatar__img">
              <app-image-picker
                [keyPrefix]="userProfile.cognitoId + '/internal-avatar'"
                [isRounded]="true"
                [image]="userProfile?.userData?.avatarUrl"
                (onImageSelect)="updateUserData('avatarUrl', $event)"
                [@fadeInOut]
              ></app-image-picker>
            </div>
            <span class="gc-avatar__dot"></span>
          </div>
        </div>

        <!-- Player identity + editable fields -->
        <div class="col-12 col-sm col-lg-3">
          <div class="gc-section-label">
            <i class="fa fa-id-badge"></i> {{ 'PROFILE.AVATAR_BLOCK.NICK_NAME_TITLE' | translate }} &amp;
            {{ 'PROFILE.AVATAR_BLOCK.STATUS_TITLE' | translate }}
          </div>
          <br />
          <div class="gc-fields mt-1">
            <ctn-inline-edit
              [maxLength]="15"
              name="nickname"
              [label]="'PROFILE.AVATAR_BLOCK.NICK_NAME_TITLE' | translate"
              [value]="userProfile?.userData?.nickname"
              (change)="updateUserData('nickname', $any($event.target).value)"
            ></ctn-inline-edit>
            <ctn-inline-edit
              [maxLength]="100"
              name="status"
              [label]="'PROFILE.AVATAR_BLOCK.STATUS_TITLE' | translate"
              [value]="userProfile?.userData?.status"
              (change)="updateUserData('status', $any($event.target).value)"
            ></ctn-inline-edit>
          </div>
        </div>

        <!-- XP / Level -->
        <div class="col-12 col-md-6 col-lg-3" *ngIf="level" [@fadeInOut]>
          <div class="gc-section-label">
            <i class="fa fa-star"></i> {{ 'PROFILE.MY_JOURNEY_BLOCK.TITLE' | translate }}
          </div>
          <br />
          <div class="gc-xp-card mt-1">
            <div class="d-flex align-items-center gap-2 mb-2">
              <div class="gc-xp-card__icon">
                <app-s3-image [image]="level.icon"></app-s3-image>
              </div>
              <div class="flex-grow-1 overflow-hidden">
                <div class="gc-xp-card__level">{{ level.name }}</div>
                <div
                  class="gc-xp-card__pts"
                  [innerHTML]="'PROFILE.MY_JOURNEY_BLOCK.EXP_POINTS' | translate: { points: points }"
                ></div>
              </div>
            </div>
            <div class="gc-xp-track">
              <div
                class="gc-xp-fill"
                [style.width.%]="((points - level.points) * 100) / (nextLevel.points - level.points)"
              >
                <span class="gc-xp-fill__tip"></span>
              </div>
            </div>
            <div class="gc-xp-labels d-flex justify-content-between mt-1">
              <span>{{ level.points }} XP</span>
              <span *ngIf="nextLevel.points - points >= 0" class="gc-xp-labels__next">
                {{ nextLevel.points - points }} XP to next
              </span>
              <span>{{ nextLevel.points }} XP</span>
            </div>
          </div>
        </div>

        <!-- Activity feed + theme toggle -->
        <div class="col-12 col-md-6 col-lg">
          <div class="gc-section-label">
            <i class="fa fa-bolt"></i> {{ 'PROFILE.MY_TEAMS_ACTIVITY_BLOCK_TITLE' | translate }}
          </div>
          <br />
          <div class="gc-activity-card mt-1">
            <div class="gc-activity-card__body">
              <app-gamification-events-list [memberId]="userProfile?.teamId"></app-gamification-events-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ══════════════════════════════════════════
       TAB NAV
  ══════════════════════════════════════════ -->
  <div class="gc-tabs-nav">
    <div class="gc-tabs-nav__inner d-flex overflow-auto">
      <button class="gc-tab" [class.gc-tab--active]="selectedIndex === 0" (click)="selectedIndex = 0">
        <i class="fa fa-bolt"></i>
        <span class="d-none d-sm-inline">{{ 'PROFILE.TAB_MY_SKILLS' | translate }}</span>
      </button>
      <button class="gc-tab" [class.gc-tab--active]="selectedIndex === 1" (click)="selectedIndex = 1">
        <i class="fa fa-bar-chart"></i>
        <span class="d-none d-sm-inline">{{ 'PROFILE.TAB_MY_STATISTICS' | translate }}</span>
      </button>
      <button class="gc-tab" [class.gc-tab--active]="selectedIndex === 2" (click)="selectedIndex = 2">
        <i class="fa fa-trophy"></i>
        <span class="d-none d-sm-inline">{{ 'PROFILE.TAB_AWARDS' | translate }}</span>
      </button>
      <button class="gc-tab" [class.gc-tab--active]="selectedIndex === 3" (click)="selectedIndex = 3">
        <i class="fa fa-comments"></i>
        <span class="d-none d-sm-inline">{{ 'PROFILE.TAB_FEEDBACK' | translate }}</span>
      </button>
      <button class="gc-tab" [class.gc-tab--active]="selectedIndex === 4" (click)="selectedIndex = 4">
        <i class="fa fa-shield"></i>
        <span class="d-none d-sm-inline">{{ 'PROFILE.TAB_LEAGUES' | translate }}</span>
      </button>
      <button class="gc-tab" [class.gc-tab--active]="selectedIndex === 5" (click)="selectedIndex = 5">
        <i class="fa fa-gamepad"></i>
        <span class="d-none d-sm-inline">{{ 'PROFILE.TAB_CHALLENGES' | translate }}</span>
      </button>
      <button class="gc-tab" [class.gc-tab--active]="selectedIndex === 6" (click)="selectedIndex = 6">
        <i class="fa fa-dollar"></i>
        <span class="d-none d-sm-inline">{{ 'PROFILE.TAB_CHALLENGE_WAGERS' | translate }}</span>
      </button>
      <button class="gc-tab" [class.gc-tab--active]="selectedIndex === 7" (click)="selectedIndex = 7">
        <i class="fa fa-list-alt"></i>
        <span class="d-none d-sm-inline">{{ 'PROFILE.TAB_POINTS_STATEMENT' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- ══════════════════════════════════════════
       TAB CONTENT
  ══════════════════════════════════════════ -->
  <div class="gc-content">
    <!-- Skills -->
    <div *ngIf="selectedIndex === 0" class="gc-panel">
      <div class="row g-3">
        <div class="col-12 col-xl-6">
          <div class="gc-card">
            <div class="gc-card__header">
              <i class="fa fa-language"></i>
              {{ 'PROFILE.LOCALES_TITLE' | translate }}
            </div>
            <div class="gc-card__body gc-card__body--scroll">
              <app-capabilities-list
                [capabilities]="localeCapabilities"
                [withReverse]="true"
                [noMargin]="true"
              ></app-capabilities-list>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="gc-card">
            <div class="gc-card__header">
              <i class="fa fa-sitemap"></i>
              {{ 'PROFILE.CAPABILITIES_TITLE' | translate }}
            </div>
            <div class="gc-card__body gc-card__body--scroll">
              <app-capabilities-list
                [capabilities]="keywordsCapabilities"
                [withTranslate]="false"
              ></app-capabilities-list>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Statistics -->
    <div *ngIf="selectedIndex === 1" class="gc-panel">
      <app-my-statistics2 [isActive]="selectedIndex === 1"></app-my-statistics2>
    </div>

    <!-- Awards -->
    <div *ngIf="selectedIndex === 2" class="gc-panel">
      <div class="row g-3">
        <div class="col-12 col-xl-6">
          <div class="gc-card">
            <div class="gc-card__header">
              <i class="fa fa-gamepad"></i>
              {{ 'LIST_ACHIEVEMENTS.TITLE' | translate }}
              <span class="gc-card__sub ms-auto">{{ 'LIST_ACHIEVEMENTS.DESCRIPTION' | translate }}</span>
            </div>
            <div class="gc-card__body gc-card__body--scroll">
              <app-achievements-list
                [achievements]="achievements[0]"
                [achievementProgress]="achievementProgress"
              ></app-achievements-list>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="gc-card">
            <div class="gc-card__header">
              <i class="fa fa-trophy"></i>
              {{ 'PROFILE.SPECIAL_AWARDS.TITLE' | translate }}
              <span class="gc-card__sub ms-auto">{{ 'PROFILE.SPECIAL_AWARDS.DESCRIPTION' | translate }}</span>
            </div>
            <div class="gc-card__body gc-card__body--scroll">
              <app-achievements-list
                [achievements]="achievements[1]"
                [achievementProgress]="achievementProgress"
              ></app-achievements-list>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Feedback -->
    <div *ngIf="selectedIndex === 3" class="gc-panel">
      <div class="gc-card">
        <div class="gc-card__header">
          <i class="fa fa-comments"></i>
          {{ 'PROFILE.TAB_FEEDBACK' | translate }}
        </div>
        <div class="gc-card__body">
          <app-feedback-comments-list></app-feedback-comments-list>
        </div>
      </div>
    </div>

    <!-- Leagues -->
    <div *ngIf="selectedIndex === 4" class="gc-panel">
      <app-league-statistics [isActive]="selectedIndex === 4"></app-league-statistics>
    </div>

    <!-- Challenges -->
    <div *ngIf="selectedIndex === 5" class="gc-panel">
      <app-challenges-list
        [autoRefresh]="selectedIndex === 5"
        (onAddChallengeWager)="addChallengeWager()"
      ></app-challenges-list>
    </div>

    <!-- Wagers -->
    <div *ngIf="selectedIndex === 6" class="gc-panel">
      <app-challenge-wagers-list
        [autoRefresh]="selectedIndex === 6"
        [showChallenges]="true"
      ></app-challenge-wagers-list>
    </div>

    <!-- Points Statement -->
    <div *ngIf="selectedIndex === 7" class="gc-panel">
      <app-score-history-list [autoRefresh]="selectedIndex === 7"></app-score-history-list>
    </div>
  </div>
</div>
